import React, { useState, useEffect } from "react";
import { Line, Bar } from "react-chartjs-2";
import "bootstrap/dist/css/bootstrap.min.css";
import 'chart.js/auto';
import { useMyContext } from "../../../components/Provider/CommonProvider";

const PartnerPayout_Analytics = ({ partnerId }) => {
    const { fetchRequest } = useMyContext();
    const BaseUrl = process.env.REACT_APP_Baseurl;
    const [loading, setLoading] = useState(false);
    const [earningsData, setEarningsData] = useState([]);
    const [lineChartData, setLineChartData] = useState({ labels: [], datasets: [] });
    const [barChartData, setBarChartData] = useState({ labels: [], datasets: [] });

    const role = localStorage.getItem('role');
    const userId = localStorage.getItem('user_id');
    const effectivePartnerId = partnerId || (role === "4" ? userId : undefined);

    useEffect(() => {
        fetchAnalytics();
    }, [effectivePartnerId]);

    const fetchAnalytics = async () => {
        setLoading(true);
        try {
            const response = await fetchRequest({
                method: "GET",
                url: `${BaseUrl}/admin/partner/payout-analytics`,
                params: { partner_id: effectivePartnerId }
            });
            if (response?.status) {
                setEarningsData(response.stats || []);
                setLineChartData(response.lineChart || { labels: [], datasets: [] });
                setBarChartData(response.barChart || { labels: [], datasets: [] });
            }
        } catch (error) {
            console.error("Error fetching payout analytics:", error);
        } finally {
            setLoading(false);
        }
    };

    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { display: true, position: "top" },
            tooltip: { enabled: true },
        },
        scales: {
            x: { grid: { display: false } },
            y: { grid: { color: "#ddd" } },
        },
    };

    return (
        <div className="container">
            <div className="row payoutgraphic">
                <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <h6 className="text-center">Partner Payout</h6>
                    <span className="text-center d-block text-muted">Historical payout trends</span>
                    <div className="chart-container mt-3" style={{ height: "300px" }}>
                        {lineChartData.labels.length > 0 ? (
                            <Line data={lineChartData} options={chartOptions} />
                        ) : (
                            <div className="d-flex align-items-center justify-content-center h-100 bg-light rounded">
                                <span className="text-muted">No data available</span>
                            </div>
                        )}
                    </div>
                    <table className="table table-borderless mt-2">
                        <thead>
                            <tr>
                                <th colSpan="2" className="text-center">Current Statistics</th>
                            </tr>
                        </thead>
                        <tbody>
                            {earningsData.length > 0 ? (
                                earningsData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.label}:</td>
                                        <td className="text-end fw-bold">{item.value}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="2" className="text-center text-muted">No stats found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mt-3">
                    <h6 className="text-center">Earnings Analytics</h6>
                    <span className="text-center d-block text-muted">Revenue breakdown by period</span>
                    <div className="chart-container mt-3" style={{ height: "300px" }}>
                        {barChartData.labels.length > 0 ? (
                            <Bar data={barChartData} options={chartOptions} />
                        ) : (
                            <div className="d-flex align-items-center justify-content-center h-100 bg-light rounded">
                                <span className="text-muted">No data available</span>
                            </div>
                        )}
                    </div>
                    <table className="table table-borderless mt-2">
                        <thead>
                            <tr>
                                <th colSpan="2" className="text-center">Earnings Breakdown</th>
                            </tr>
                        </thead>
                        <tbody>
                            {earningsData.length > 0 ? (
                                earningsData.slice(0, 3).map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.label}:</td>
                                        <td className="text-end fw-bold">{item.value}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="2" className="text-center text-muted">No breakdown found</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PartnerPayout_Analytics;

